import {secured as axios} from "../../../axios";

export class Community {
    static async getUserCommunities(userId) {
        const res = await axios.get(`/user/communities`);
        console.log(res.data)
        return res.data;
    }

    static async getCommunityInfo(id) {
        const res = await axios.get(`${axios.defaults.apiURL}/community/${id}`);
        return {'info' : res.data[0]};
    }

    static async getCommunityEvent(id) {
        const res = await axios.get(`${axios.defaults.apiURL}/community/${id}/events`);
        return {"event" : res.data};
    }

    static async getCommunityActuality(id) {
        const res = await axios.get(`${axios.defaults.apiURL}/community/${id}/actualities`);
        return {'actuality' : res.data};
    }

    static async getCommunities() {
        const res = await axios.get(`${axios.defaults.apiURL}/communities`);
        return res.data
    }
}
